import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import DuplicatedLeadsTable from "../../../components/Lead/duplicatedLeads"

const DuplicatedLeads = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Repeated Leads | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <DuplicatedLeadsTable />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default DuplicatedLeads
